import { History, Location } from "history";

import { Link as LinkType } from "common/types/routing";

import { addValueToLinkState } from "seneca-common/utils/routing";

const locationStateFrom = "from";
export type Link = LinkType;

export const linkHasState = (link: Link): boolean =>
  !!link && typeof link !== "string" && (link as any).state !== undefined;

export const modalLink = (link: Link): Location =>
  addValueToLinkState(link as any, {
    modal: true
  });

export const addLinkMeta = (link: Link, meta: Record<string, any>): Location =>
  addValueToLinkState(link as any, {
    meta
  });

export const isModalLink = (link: Link): boolean =>
  linkHasState(link) && !!(link as any).state.modal; // $FlowFixMe - we've checked link has state

export const getLinkMeta = (
  link: Link // @ts-ignore - we've checked link has state
) => linkHasState(link) && (link as any).state.meta;

export const makeRedirectLink = (link: Link, referrer: Link): Location =>
  addValueToLinkState(link as any, {
    referrer
  });

export const getRedirectLinkReferrer = (link: Link): Link | null | undefined =>
  linkHasState(link) && (link as any).state.referrer; // $FlowFixMe - we've checked link has state

export const makeCanNavigateBackLink = (link: Link) =>
  addValueToLinkState(link as any, {
    canNavigateBack: true
  });

export const canNavigateBack = (
  link: Link // @ts-ignore - we've checked link has state
) => linkHasState(link) && (link as any).state.canNavigateBack;

export const linkToPreRedirectOrNextPage = (
  location: Location,
  linkToNextPage: string
) => {
  return location.state && location.state[locationStateFrom]
    ? location.state[locationStateFrom]
    : linkToNextPage;
};

export const addLocationWithStateToHistory = (
  history: History,
  location: Location,
  pathname: string
) => {
  history.push({
    pathname,
    state: location && location.state
  });
};
